import React, { MutableRefObject } from 'react';
import { SwipeableHandlers } from 'react-swipeable';
import Hls from 'hls.js';
import { Slide } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { isMobileOnly } from 'react-device-detect';
import clsx from 'clsx';
import { Player, Spinner } from '../../../../../components/index';
import MediaPreviewStyles from './styles';
import { Article } from '../../../../../types/items';
import {
  getLargeVideoThumbnailUrl,
  getLargeDocumentThumbnailUrl,
  getStaticVideo,
} from '../utils';
import NoPreview from './NoPrivew';
import { selectCurrentUser } from '../../../../../store/modules/users/selectors';

type Props = {
  media: Article;
  swipeable?: SwipeableHandlers;
  slideDirection: 'left' | 'right' | 'up' | 'down';
  isChangePreviewMedia: number | null;
  refPreviewContent: MutableRefObject<HTMLDivElement | null>;
  onPlay?: () => void;
  onPause?: () => void;
  onResizePlayer?: (props: { height: string; width: string }) => void;
};

const isSuportedHls = Hls.isSupported();

const MediaVideo = ({
                      media,
                      swipeable,
                      slideDirection,
                      isChangePreviewMedia,
                      refPreviewContent,
                      onPause,
                      onPlay,
                      onResizePlayer,
                    }: Props) => {
  const classes = MediaPreviewStyles();
  const { data: currentUser } = useSelector(selectCurrentUser);

  let srcVideo = media.ref.video?.streaming_url || media.document_download_url?.url;
  let isStream = media.video_id !== -1;
  const staticVideo = getStaticVideo(media.ref.video?.ref?.statics || []);

  const documentThumbnails = media.ref.document?.thumbnails || [];
  const videoThumbnails = media.ref.video?.ref.thumbnails || [];
  const isProcessingMedia = media.ref.video?.ref?.is_processing || false;

  if (isProcessingMedia) {
    return (
      <NoPreview
        swipeable={swipeable}
        slideDirection={slideDirection}
        isChangePreviewMedia={isChangePreviewMedia}
      />
    );
  }

  if (isStream && !isSuportedHls && staticVideo) {
    console.log('not support');
    isStream = false;
    srcVideo = staticVideo.url;
  }

  const poster = getLargeVideoThumbnailUrl(videoThumbnails) || getLargeDocumentThumbnailUrl(documentThumbnails);

  if (!srcVideo) {
    return (
      <div {...swipeable} className={classes.wrapper}>
        <Spinner />
      </div>
    );
  }

  return (
    <Slide
      direction={slideDirection}
      in={isChangePreviewMedia === null}
      mountOnEnter
      unmountOnExit
      timeout={300}
    >
      <div className={clsx(classes.playerWrapper, {
        [classes.mobilePlayerWrapper]: isMobileOnly,
      })}
      >
        <Player
          src={srcVideo}
          swipeable={swipeable}
          isStream={isStream}
          key={srcVideo}
          poster={poster}
          refPreviewContent={refPreviewContent}
          staticVideo={staticVideo}
          videoMeta={{
            viewer_user_id: currentUser?.id || -1,
            video_title: media.ref.video?.title || media.ref.document?.title || '',
            video_id: media.ref.video?.id || media.ref.document?.id || -1,
          }}
          onPause={onPause}
          onPlay={onPlay}
          onResizePlayer={onResizePlayer}
        />
      </div>
    </Slide>
  );
};

export default MediaVideo;
